import axios from 'axios'
import JSEncrypt from 'jsencrypt'
import qs from 'qs'
import router from './router'
import { isProduction } from './utils'
import { getCSRFToken } from './utils/const'

import { MessageBox } from 'element-ui'

import { CODE_OK } from './utils/const'

const http = axios.create({
  baseURL: isProduction ? '/' : '/api/',
  headers: {
    'x-requested-with': 'XMLHttpRequest'
  }
})

const _MessageBox = val => {
  MessageBox.alert(val, 'prompt', {
    confirmButtonText: 'ok',
    cancelButtonText: 'ok',
    dangerouslyUseHTMLString: true
  })
}

/* rsa public key */
const $pubKey = `MIGfMA0GCSqGSIb3DQEBAQUAA4GNADCBiQKBgQC/sBd9MuRhSItMKrurl9Ui5pRn
T/4wUpImOOI1oyFziLiPSvuI+9XJwoiZyL8xiovHz3fQVLnoEsCv5MwTU0InJZZt
2Bnu7FbTnGTzfrrukGp2NU04CHTNU29/HsX0WRfQmHX55H5xSJzNH2iGZsjiG8IX
XtQ6tlFberBgvTeDowIDAQAB`

var encrypt = new JSEncrypt()

encrypt.setPublicKey($pubKey)

function do_encrypt (text) {
  var l = 0
  var len = text.length
  var code = []
  var n = Math.ceil(len / 36)
  for (var i = 0; i < n; i++) {
    code[i] = encrypt.encrypt(text.substring(l, (l = l + 36)))
  }
  code = code.join('|')
  return code
}

/* let a = { title: '111' }
console.log(this.encrypt)
server
  .test_apply({ data: encrypt.encrypt(JSON.stringify(a)) })
  .then(res => { })
  .catch(err => { })

let CSRFToken = '' */
const clear_token = ['/sign-up/login', '/forget-pw/request-password-reset']

http.interceptors.request.use(async function (config) {
  console.log('config', config)

  if (clear_token.indexOf(config.url) !== -1) {
    localStorage.uk_token = ''
  }

  if (localStorage.uk_token) {
    config.headers['Access-Token'] = localStorage.uk_token
  }
  if (config.method === 'post') {
    const data = config.data || {}
    // if (!CSRFToken) {
    //   CSRFToken = await getCSRFToken()
    // }
    // config.data = qs.stringify(Object.assign(data, CSRFToken)) //  给所有 post 请求添加 csrftoken 并且序列化对象
    console.log('reqquest: --- api:', config.url, '--- params:', config.data)
    if (config.data) {
      config.data = qs.stringify({
        data: do_encrypt(JSON.stringify(config.data))
      })
    }
  }
  return config
})

const messageObj = {
  Email: 'Email',
  Phone: 'Phone',
  password: 'Password',
  phone_country_code: 'Country code',
  passcode: 'Country code',
  other_contact_number: 'Other contact number',
  verify_code: ''
}

http.interceptors.response.use(
  function (response) {
    const data = response.data
    console.log('res: --- api:', response.config.url, '--- ', data)
    if (response.config.direct) {
      // 直接返回 data，不进行后续处理
      return data
    }

    if (data.code === 403) {
      router.push({
        name: 'login'
      })
      return Promise.reject(new Error('no login!'))
    }

    const message = data.message || 'Server exception'
    if (data.code === 400) {
      // 有错误提示信息
      console.log(400)
      if (!response.config.noMsg) {
        // 处理不需要提示窗的情况
        const result = data.data
        let str = ''
        if (typeof result === 'object') {
          const errKey = Object.keys(result)[0]
          str = (messageObj[errKey] || errKey) + ' ' + result[errKey]
        } else if (typeof message === 'object') {
          const errKey = Object.keys(message)[0]
          str = (messageObj[errKey] || errKey) + ' ' + message[errKey]
        } else {
          str = message
        }
        _MessageBox(str)
      }
    }

    if (data.code !== CODE_OK) {
      _MessageBox(message)
      return Promise.reject(new Error(message))
    }
    return data.data
  },
  function (error) {
    console.log(error)
    _MessageBox('Server exception，Please try again later!')
    return Promise.reject(new Error('Server exception!'))
  }
)

export default http
